import type { AppError } from '@core/api/normalizeError'

// Error codes the BE may emit on POST /orders. Source of truth:
// investor-service/src/core/exceptions/errors/order.errors.ts
export const ORDER_ERROR_MESSAGES: Record<string, string> = {
  ORDER_INSUFFICIENT_WALLET_BALANCE:
    'Your wallet balance is too low to complete this investment. Add funds to continue.',
  WALLET_INSUFFICIENT_BALANCE:
    'Your wallet balance is too low to complete this investment. Add funds to continue.',
  ORDER_OFFERING_NOT_AVAILABLE: 'This offering is no longer available for investment.',
  ORDER_INSUFFICIENT_TOKENS: 'Not enough tokens available to fulfil this order.',
  PROPERTY_FULLY_FUNDED: 'This property is fully funded.',
  ORDER_BELOW_MIN_INVESTMENT: 'The investment amount is below the minimum for this offering.',
  ORDER_EXCEEDS_MAX_INVESTMENT: 'The investment amount exceeds the maximum for this offering.',
  ORDER_EXCEEDS_MAX_ALLOCATION:
    'This exceeds the maximum allocation allowed for a single investor on this offering.',
  ORDER_INVALID_TOKEN_QUANTITY: 'Token quantity must be a positive whole number.',
  ORDER_INVALID_IDEMPOTENCY_KEY: 'Please retry placing your order.',
  ACCOUNT_NOT_READY_FOR_TRANSACTION:
    'Your account is not ready for transactions. Complete KYC, activate your wallet, and verify your bank account.',
  WALLET_NOT_ACTIVE: 'Your crypto wallet is not active yet.',
  BANK_ACCOUNT_NOT_FOUND: 'Add a verified bank account before placing an order.',
  BANK_ACCOUNT_NOT_VERIFIED: 'Your bank account is pending verification.',
}

const INSUFFICIENT_BALANCE_CODES = new Set([
  'ORDER_INSUFFICIENT_WALLET_BALANCE',
  'WALLET_INSUFFICIENT_BALANCE',
])

export const resolveOrderError = (
  error: AppError,
): { message: string; isInsufficientBalance: boolean } => {
  const code = error.errorCode
  return {
    message: (code && ORDER_ERROR_MESSAGES[code]) || error.message || 'Failed to place order.',
    isInsufficientBalance: !!code && INSUFFICIENT_BALANCE_CODES.has(code),
  }
}
